import moment from 'moment';
import BaseMitConfigService from './BaseMitConfigService.js';
import BaseMitExternalApiService from './BaseMitExternalApiService.js';
import BaseMitCSAILLdapService from './BaseMitCSAILLdapService.js';
import BaseMitReserveDateTimeService from './BaseMitReserveDateTimeService.js'

class BaseMitReserveSpacesService {
  constructor() {
    this.service = new BaseMitExternalApiService();
    this.serviceDateTime = new BaseMitReserveDateTimeService();
    this.spacesList = null;
    this.spaceDict = null;
    this.spaceListPromise = null;
  }
  getSpaceStats(spaces){

    let stats = {
        types:[],
        floors:[],
        buildings:[]
    }

    spaces.forEach(
        (s) => {
            if( stats.types.indexOf(s.useType) === -1 ){
                stats.types.push(s.useType)
            }
            if( stats.floors.indexOf(s.level) === -1 ){
                stats.floors.push(s.level)
            }
            if( stats.buildings.indexOf(s.buildingMitId) === -1 ){
                stats.buildings.push(s.buildingMitId)
            }
        }
    );


    return stats;
  }

  dateRangeConflict(moment1Start, moment1End, moment2Start, moment2End){
      return moment2Start.isBetween(moment1Start, moment1End, 'minutes', '()') // all inclusive
      ||
      moment2End.isBetween(moment1Start, moment1End, 'minutes', '()'); // all inclusive
  }
  checkDateConfictsInReservations(reservations, momentStart, momentEnd){
      for(let x = 0; x < reservations.length; x++){
          if(this.dateRangeConflict(reservations[x].startTime, reservations[x].endTime, momentStart, momentEnd) === true){
              return true;
          }
      }

      return false;
  }

  getCSAILUsers(searchterm){

      return new Promise ((resolve, reject) => {
          BaseMitCSAILLdapService.requestGetUsers(searchterm)
             .then((users) => {
                 return resolve(users);
             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }

  getAllReservations(){
      return new Promise ((resolve, reject) => {

          let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
          this.service.getData('GET', spacesUrl, '/api/v1/manager/reservations')
             .then((response) => {
                this.adaptReservationsToUIModel(response.reservations);

                return resolve(response);
             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }

  getReservationsForSpaces(startUTC, endUTC){
      startUTC = startUTC || moment().startOf('day').utc().format('YYYY-MM-DD hh:mm A');
      endUTC = endUTC || moment().endOf('day').utc().format('YYYY-MM-DD hh:mm A');

      return new Promise ((resolve, reject) => {
          let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
          this.service.getData('GET', spacesUrl, '/api/v1/user/reservations?startUTC='+startUTC+'&endUTC='+endUTC)
             .then((response) => {
                this.adaptReservationsToUIModel(response.reservations);

                return resolve(response);
             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }

  saveMyRecurringReservation(recurringReservation){

      // recurringReservation.events = this.serviceDateTime.convertRecurringDatesListToUTC(recurringReservation.events);
      this.adaptToAPIModel(recurringReservation);

      return new Promise ((resolve, reject) => {
          let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
          this.service.getData('POST', spacesUrl, '/api/v1/user/reservations/recurring', recurringReservation)
             .then((response) => {
                 return resolve(response);
             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }


  adaptSpacesToUIModel(spaces, spacesInfoDict){
    for(let x = 0; x < spaces.length; x++){
      spaces[x].dates_local = {
        createDt: spaces[x].createDt ? moment(spaces[x].createDt).local().format('MMM DD YYYY'): null,
        lastEditedDt: spaces[x].lastEditedDt ? moment(spaces[x].lastEditedDt).local().format('MMM DD YYYY'): null,
        nextStartTime: spaces[x].nextStartTime ? moment(spaces[x].nextStartTime).local().format('MMM DD YYYY'): 'Open',
        nextStartTimeLeft: spaces[x].nextStartTime ? moment(spaces[x].nextStartTime).local().fromNow(true): moment().endOf('day').fromNow(true)
      };

      if(spaces[x].conflicts){
          for(let c of spaces[x].conflicts){
            c.startDateTime = moment(c.startTime).local();
            c.endDateTime = moment(c.endTime).local();
            
            delete c.startTime;
            delete c.endTime;
          }
      }

      if(spacesInfoDict[spaces[x].mitId]){
        spaces[x].buildingMitId = spacesInfoDict[spaces[x].mitId].buildingMitId;
        spaces[x].parentMitId = spacesInfoDict[spaces[x].mitId].parentMitId;
        spaces[x].level = spacesInfoDict[spaces[x].mitId].level;
        spaces[x].sqfoot = spacesInfoDict[spaces[x].mitId].sqfoot;
        spaces[x].org = spacesInfoDict[spaces[x].mitId].org;
        spaces[x].useType = spacesInfoDict[spaces[x].mitId].useType;
        spaces[x].spaceType = spacesInfoDict[spaces[x].mitId].spaceType;
        spaces[x].name = spacesInfoDict[spaces[x].mitId].name;
        if(spaces[x].name.length === 0 ) spaces[x].name = spaces[x].mitId;
        spaces[x].description = spacesInfoDict[spaces[x].mitId].description;
        spaces[x].locationUrl = '/maps/'+spaces[x].buildingMitId+'?s='+spaces[x].mitId+'?l='+spaces[x].level
        spaces[x].maxCapacity = spacesInfoDict[spaces[x].mitId].personCapacity;
        spaces[x].equipment = spacesInfoDict[spaces[x].mitId].equipment;
        spaces[x].seating = spacesInfoDict[spaces[x].mitId].seating;
        spaces[x].images = spacesInfoDict[spaces[x].mitId].images;
      }
      else{
        spaces[x].buildingMitId = spaces[x].mitId.split('-')[0];
        spaces[x].parentMitId = 'unknown';
        spaces[x].level = 0
        spaces[x].sqfoot = 0;
        spaces[x].org = 'unknown';
        spaces[x].useType = 'unknown';
        spaces[x].spaceType = 'unknown';
        spaces[x].name = spaces[x].mitId;
        spaces[x].exists = false;
        spaces[x].description = "Space does not exist in Map application"
        spaces[x].locationUrl = null
        spaces[x].maxCapacity = 0;
        spaces[x].equipment = '';
        spaces[x].seating = '';
        spaces[x].images = null;
      }
      

      if(spaces[x].spaceType == 'object'){
        spaces[x].containingSpace = spaces[x].parentMitId;
        spaces[x].nameFormatted = spaces[x].name + ' (' +spaces[x].containingSpace + ')';
      }
      else if(spaces[x].name != spaces[x].mitId){
        spaces[x].nameFormatted = spaces[x].name + ' (' +spaces[x].mitId + ')';
      }
      else{
        spaces[x].nameFormatted = spaces[x].mitId;
      }
    }

    return spaces;
  }
  getAdminReservableSpaces(){
      return new Promise ((resolve, reject) => {
          let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
          this.service.getData('GET', spacesUrl, '/api/v1/admin/reservablespaces/')
             .then((response) => {
                 let ids = response.spaces.map(item => item.mitId);
                 //We need to skip using the cache generated by the rooms this user has access too. 
                 //It can cause an edge case where an admin user doesn't have access but still can edit the rooms
                 //This makes the app think since it wasn't in the initial cache that it doesn't exist in the maps app
                 //So bypassing here for now. Need a better way to handle this. Probably better to either just gett all possible room details at app load or cache on api side
                 this.getSpacesDetailsByIds(ids, true)
                   .then((spacesDict) => {
                       this.adaptSpacesToUIModel(response.spaces, spacesDict);

                       return resolve(response);
                   })
                   .catch((error) => {
                       console.log('ERROR:', error);
                       return reject(error);
                   });


             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }
  getAvailableSpacesFromNow(availableFor, unit){
      let dateTimeNow = new moment();
      let startUTC = dateTimeNow.utc().format("YYYY-MM-DD hh:mm A");
      let endUTC = dateTimeNow.add( availableFor, unit).utc().format("YYYY-MM-DD hh:mm A");

      //what
      return this.getAvailableSpaces(startUTC,endUTC);
  }
    getAvailableSpaces(startDateTimeUTC, endDateTimeUTC, excludeReservationUniqueId){
        return new Promise ((resolve, reject) => {

          let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
          let path =  '/api/v1/user/reservablespaces/available?startUTC='+startDateTimeUTC+'&endUTC='+endDateTimeUTC;
          //we don't want to show conflics or unavailability for an existing reservation, its own time should be considered open as its already booked
          if(excludeReservationUniqueId){
            path += '&excludeId='+excludeReservationUniqueId;
          }
          this.service.getData('GET', spacesUrl, path)
            .then((response) => {
                let ids = response.spaces.map(item => item.mitId);
                this.getSpacesDetailsByIds(ids)
                    .then((spacesDict) => {
                        this.adaptSpacesToUIModel(response.spaces, spacesDict);
                        return resolve(response);
                    })
                    .catch((error) => {
                        console.log('ERROR:', error);
                        return reject(error);
                    });
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
        })
    }
  getReservableSpace(mitId){
      return new Promise ((resolve, reject) => {
          this.getSpacesDetailsByIds(mitId)
            .then((spacesDict) => {
                let space = {mitId:mitId}
                this.adaptSpacesToUIModel([space], spacesDict);
                return resolve(space);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
     })
  }

  getSpacesWithConflicts(dateTimeList, existingReservation){
      return new Promise ((resolve, reject) => {


          let requestModel = {
            dateTimeList:dateTimeList,
            excludeUniqueIds:null
          }
          
          if(existingReservation.uniqueId){
            requestModel.excludeUniqueIds = [existingReservation.uniqueId];
          }
          let results = {
            spaces:{
                dict:[],//target mitId if specified, otherwise everything goes in all
                list:[],
                suggestions:[]
            }
          }
          let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
          this.service.getData('POST', spacesUrl, '/api/v1/user/reservations/potential/conflicts', requestModel)
             .then((response) => {
                 let ids = response.spaces.map(item => item.mitId);

                 this.getSpacesDetailsByIds(ids)
                   .then((spacesDict) => {
                       this.adaptSpacesToUIModel(response.spaces, spacesDict);

                        for(let x = 0; x < response.spaces.length; x++){
                            results.spaces.dict[response.spaces[x].mitId] = response.spaces[x];

                            if(response.spaces[x].conflicts.length === 0){
                                results.spaces.suggestions.push(response.spaces[x]);
                            }
                        }
                        results.spaces.list = response.spaces;
                       
                       return resolve(results);
                   })
                   .catch((error) => {
                       console.log('ERROR:', error);
                       return reject(error);
                   });
             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }

  getReservableSpaces(){
      return new Promise ((resolve, reject) => {
        if(this.cachedReservableSpaces){
            return resolve(this.cachedReservableSpaces);
        }
        let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('GET', spacesUrl, '/api/v1/user/reservablespaces')
             .then((response) => {
                 let ids = response.spaces.map(item => item.mitId);

                 this.getSpacesDetailsByIds(ids)
                   .then((spacesDict) => {
                        this.cachedSpaceDetails = spacesDict;
                       this.adaptSpacesToUIModel(response.spaces, spacesDict);
                       this.cachedReservableSpaces = response;
                       return resolve(response);
                   })
                   .catch((error) => {
                       console.log('ERROR:', error);
                       return reject(error);
                   });
             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }

  saveReservableSpace(reservableSpace){
      return new Promise ((resolve, reject) => {
        let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('POST', spacesUrl, '/api/v1/admin/reservablespaces/', reservableSpace)
             .then((response) => {
                 return resolve(response);
             })
             .catch((error) => {
               console.log('ERROR:', error);
               return reject(error);
             });
      })
  }
  deleteReservableSpace(reservableSpace){
    return new Promise ((resolve, reject) => {
        let spacesUrl = BaseMitConfigService.get('CLIENT_API_RESERVE');
        this.service.getData('DELETE', spacesUrl, '/api/v1/admin/reservablespaces/'+reservableSpace.id)
           .then((response) => {
               return resolve(response);
           })
           .catch((error) => {
             console.log('ERROR:', error);
             return reject(error);
           });
    })
  }

  //Hit the spaces API
  //This might be moved to BaseMitSpacesService.js
  getSpacesDetailsByIds(spaceIds, skipCache){
      return new Promise ((resolve, reject) => {
          let url = BaseMitConfigService.get('CLIENT_API_SPACES');

          if(this.cachedSpaceDetails && (typeof skipCache === 'undefined' || skipCache === null || skipCache === false))
          {
            return resolve(this.cachedSpaceDetails);
          }
          this.service.getData('GET', url, '/api/v2/user/spaces?format=dict&ids='+spaceIds)
            .then((data) => {
                return resolve(data.spaces);
            })
            .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
            });
      })
  }

  //Hit the spaces API
  //This might be moved to BaseMitSpacesService.js
  getSpacesList() {
    if(this.spaceListPromise){
        return this.spaceListPromise;
    }

    this.spaceListPromise = new Promise ((resolve, reject) => {
        if(this.spacesList){
            this.spaceListPromise = null;
            return resolve(this.spacesList);
        }

        let path = '/api/v2/user/spaces?types=space,object';
        let url = BaseMitConfigService.get('CLIENT_API_SPACES');

        this.service.getData('GET', url, path)
          .then((data) => {
              let spacesList = [];

              for(let x = 0; x < data.spaces.length; x++){
                  if(data.spaces[x].spaceType === 'floor'){
                      spacesList.push({ divider: true});
                      spacesList.push({ header: 'Floor '+ data.spaces[x].level});
                      spacesList.push({ divider: true});
                  }
                  else{
                      spacesList.push({
                        mitId:data.spaces[x].mitId,
                        mitIdShort:data.spaces[x].mitIdShort,
                        name:data.spaces[x].name,
                        type:data.spaces[x].spaceType,
                        useType:data.spaces[x].useType,
                        org:data.spaces[x].org,
                        level:data.spaces[x].level,
                        group:'Floor '+data.spaces[x].level,
                        building:data.spaces[x].buildingMitId
                      });
                  }
              }
              this.spacesList = spacesList;
              this.spaceListPromise = null;

              return resolve(this.spacesList);
          })
          .catch((error) => {
              this.spacesList = null;
              this.spaceListPromise = null;
              console.log('ERROR:', error);

              return reject(error.response.data);
          });

      });
      return this.spaceListPromise;
  }
}
export default new BaseMitReserveSpacesService();
